angular.module('smartorg.r6.navs.workspace').directive("workspace", ["$timeout", function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/workspace.html'),
            transclude: true,
            scope: {
                smartorg: '=?',
                selected: '=?',
                username: '@?',
                isInav: '=?',
                isCorteva: '=?'
            },
            link: function (scope) {
                scope.menuBox = {
                    menu: {}
                };
                scope.$on('workspace:reloadAction', function (event, args) {
                    if ('chartSettings' in scope.newConfig) {
                        scope.newConfig['chartSettings'] = args.portfolioConfig['chart'];
                        scope.newConfig['settings'] = args.portfolioConfig['table'];
                    }
                    else {
                        scope.newConfig['settings'] = args.portfolioConfig['chart'];
                    }
                    scope.$broadcast("command:" + scope.command, scope.newConfig);
                });
                scope.$on('workspace:action', function (event, args) {
                    scope.command = args.command.trim();
                    $timeout(function () {
                        scope.$apply();
                        scope.newConfig = args.config;
                        scope.newConfig['username'] = scope.username;
                        scope.$broadcast("command:" + scope.command, scope.newConfig);
                    }, 200);
                });
            }
        };
    }]);
//# sourceMappingURL=workspace-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/workspace/app/js/plumbing/workspace-directive.js